// @flow
import { configString } from 'utils/config';

const getSearchIndex = (sort: ?string) => {
  if (sort === 'relevance') {
    return configString('algolia', 'siteIndexName');
  }
  return configString('algolia', 'sitePublishedDescIndexName');
};

export default getSearchIndex;
